import { useMutation } from "@apollo/client/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, statusTypesData, urlsData } from "@/data";
import { createContributorMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useCreateContributor = () => {
    const [controller, setController] = useState(null);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [createContributorAction, { loading }] = useMutation(createContributorMutation);

    const createContributor = async ({ appleId, name, nameAr }) => {
        try {
            const newController = new AbortController();

            setController(newController);

            await createContributorAction({
                context: {
                    fetchOptions: { signal: newController.signal },
                },
                onCompleted: ({ createContributor }) => {
                    if (createContributor) navigate(urlsData.routes.contributors.url);

                    dispatch(
                        openAlert(
                            t("messages.createMsgs.success", { entity: t("contributors.entity") }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    data: {
                        appleId,
                        name,
                        name_ar: nameAr,
                    },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        } finally {
            setController(null);
        }
    };

    return {
        cancelRequest: () => controller && controller.abort(),
        createContributor,
        loading,
    };
};

export default useCreateContributor;
